//
// client-mgmt-page-state.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* jshint devel: true */
/* global angular: false, _: false */

((() => {
    angular.module('curalate').service('ClientMgmtPageState', ['$timeout', function (timeout) {
        let initComplete;
        let outstandingRequest;
        let successStatus;
        let displayMsg;
        let clearSuccessTimeoutInMs;

        // do not allow actions before the page is initialized
        initComplete = false;

        // submit has been press or loading
        outstandingRequest = true;

        // for displaying feedback to user - display message must be set, then successStatus indicates success vs. fail
        successStatus = true;
        displayMsg = null;

        // auto-clear success after timeout
        clearSuccessTimeoutInMs = 0;

        this.init = () => {
            initComplete = false;
            outstandingRequest = false;
            successStatus = true;
            displayMsg = null;
            clearSuccessTimeoutInMs = 0;
        };

        this.startAsyncAction = () => {
            outstandingRequest = true;
            successStatus = true;
            displayMsg = null;
        };

        this.disableInput = () => !initComplete || outstandingRequest;

        this.disableForm = function () {
            return this.disableInput() || this.isSuccess();
        };

        this.initFinished = function () {
            initComplete = !this.isError();
        };

        this.clearResults = () => {
            if (initComplete) {
                successStatus = true;
                displayMsg = null;
            }
        };

        this.setClearSuccessTimeout = val => {
            clearSuccessTimeoutInMs = val;
        };

        this.setSuccess = function (msg) {
            successStatus = true;
            displayMsg = msg;
            outstandingRequest = false;
            if (clearSuccessTimeoutInMs !== 0) {
                timeout(this.clearSuccess, clearSuccessTimeoutInMs);
            }
        };

        this.clearSuccess = () => {
            successStatus = true;
            displayMsg = null;
        };

        this.isSuccess = () => displayMsg !== null && successStatus;

        this.setError = errMsg => {
            successStatus = false;
            displayMsg = errMsg;
            outstandingRequest = false;
        };

        this.isError = () => displayMsg !== null && !successStatus;

        this.getDisplayMsg = () => displayMsg;
    }]);
}))();

